import statusName from './statusName'
import chipStatusColor from './chipStatusColor'

const questions = {
  statusName,
  chipStatusColor,
}

export default questions
